import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import AssetTable from '../components/Asset/AssetTable';
import AssetMap from '../components/AssetMap';
import AssetOverlay from '../components/Asset/AssetOverlay';
import { getInventory, deleteAsset, getAssetStats} from '../store/actions/assetActions';
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import { LuPlus } from "react-icons/lu";
import AssetMetric from "../components/Charts/General/AssetMetric"
import AssetStatusMetric from "../components/Charts/General/AssetStatusMetric"
import AssetQuarterMetric from "../components/Charts/General/AssetQuarterMetric"
import TopAssets from "../components/Charts/General/TopAssets"

const ITInventory = ({ assets, loading, error, getInventoryFN, deleteAssetFN, sidebar_collapsed, activeassetforworkflow, setActiveAssetForWorkflow, getAssetStatsFN, assets_data }) => {
    const [isOverlayOpen, setIsOverlayOpen] = useState(false);
    const [selectedAsset, setSelectedAsset] = useState(null);
    const [isInitialLoad, setIsInitialLoad] = useState(true);
    const [viewOption, setviewOption] = useState("Assets");

    useEffect(() => {
        getInventoryFN().finally(() => setIsInitialLoad(false));
    }, [getInventoryFN]);

    useEffect(() => {
        getAssetStatsFN().finally(() => setIsInitialLoad(false));
    }, [getAssetStatsFN]);

    useEffect(() => {
        if (activeassetforworkflow) {
            setSelectedAsset(activeassetforworkflow);
            setIsOverlayOpen(true);
            setActiveAssetForWorkflow(null);
        }
    }, [activeassetforworkflow]);

    const handleAddNew = () => {
        setSelectedAsset(null);
        setIsOverlayOpen(true);
        getAssetStatsFN();
    };

    const handleEdit = (asset) => {
        setSelectedAsset(asset);
        setIsOverlayOpen(true);
        getAssetStatsFN();
    };

    const handleDelete = (assetId) => {
        deleteAssetFN(assetId);
        getAssetStatsFN();
    };


    const handleViewStats = () => {
        setviewOption("Stats");
        getAssetStatsFN();
    };

    const handleViewAssets = () => {
        setviewOption("Assets")
    }


    if (isInitialLoad && loading) {
        return (
            <div className="flex justify-center items-center h-screen">
                <p>Loading assets...</p>
            </div>
        );
    }

    if (error) {
        return (
            <div className="flex justify-center items-center h-screen text-red-600">
                <p>Error fetching assets: {error}</p>
            </div>
        );
    }

    return (
        <div className={`flex flex-col p-4 ${sidebar_collapsed ? 'w-[100%]' : 'w-[100%]'}`}>
            {viewOption === "Assets" && (
                <>
                    <div
                        className={`flex justify-start items-center mb-4 space-x-8 transition-all duration-200 ${viewOption === "Assets" ? "pl-8 ml-3" : "pl-8 ml-0"
                            }`}
                    >
                        <button
                            onClick={handleViewAssets}
                            className={`pb-2 text-sm font-medium transition-colors duration-200 ${viewOption === "Assets"
                                    ? "text-[#3b3b3b] border-b-2 border-[#3b3b3b]"
                                    : "text-gray-500 hover:text-[#3b3b3b]"
                                }`}
                        >
                            Assets
                        </button>

                        <button
                            onClick={handleViewStats}
                            className={`pb-2 text-sm font-medium transition-colors duration-200 ${viewOption === "Stats"
                                    ? "text-[#3b3b3b] border-b-2 border-[#3b3b3b]"
                                    : "text-gray-500 hover:text-[#3b3b3b]"
                                }`}
                        >
                            Stats
                        </button>
                    </div>


                    <div className="overflow-x-auto">
                        <div className="min-w-[1100px] mx-auto max-w-[95%]">   {/* slightly wider but still centered */}
                            <AssetTable
                                data={assets || []}
                                totalPagesServer={1}
                                currentPage2={1}
                                pageSize2={10}
                                onEdit={handleEdit}
                                onDelete={handleDelete}
                            />

                            <button
                                className="mt-4 flex items-center justify-center gap-2 pt-2 pb-2 h-10 text-l bg-[#F8F8F8] text-black transition duration-200 rounded-[5px] px-5 hover:bg-opacity-70 shadow-md border border-gray-300 hover:shadow-lg hover:bg-[#F0F0F2]"
                                onClick={handleAddNew}
                            >
                                <LuPlus className="ml-[-10px] w-5 h-5" />
                                <span>Asset</span>
                            </button>
                        </div>
                    </div>

            <Popup
                open={isOverlayOpen}
                onClose={() => setIsOverlayOpen(false)}
                modal
                nested
                contentStyle={{ width: '80%', maxWidth: '800px', padding: '0', borderRadius: '8px' }}
            >
                {(close) => (
                    <AssetOverlay
                        close={() => {
                            setIsOverlayOpen(false);
                        }}
                        asset={selectedAsset}
                    />
                )}
                    </Popup>
                </>)}


            {viewOption === "Stats" && (
                <>
                     <div className="flex justify-start items-center mb-4 space-x-8 pl-8">
                        <button
                            onClick={handleViewAssets}
                            className={`pb-2 text-sm font-medium transition-colors duration-200 ${viewOption === "Assets"
                                    ? "text-[#3b3b3b] border-b-2 border-[#3b3b3b]"
                                    : "text-gray-500 hover:text-[#3b3b3b]"
                                }`}
                        >
                            Assets
                        </button>

                        <button
                            onClick={handleViewStats}
                            className={`pb-2 text-sm font-medium transition-colors duration-200 ${viewOption === "Stats"
                                    ? "text-[#3b3b3b] border-b-2 border-[#3b3b3b]"
                                    : "text-gray-500 hover:text-[#3b3b3b]"
                                }`}
                        >
                            Stats
                        </button>
                    </div>
                    <div className="flex flex-col pl-8 pr-8 pt-8 pb-4 overflow-auto bg-[#FFFFFF]" style={{ maxHeight: "calc(100vh - 100px)" }}>
                        {/* Grid Layout: 5 rows x 6 columns with increased gap */}
                        <div className="grid grid-rows-[200px_auto_auto] grid-cols-5 gap-8 w-full">

                            <div className="row-span-1 col-span-1 bg-[#FFFFFF] shadow-lg rounded-[5px]   ">
                                <div className="bg-[#ffffff] text-black px-3 py-1 flex-none flex rounded-tl-[5px] rounded-tr-[5px]">
                                    <div className="flex justify-center items-center gap-1 flex-nowrap overflow-hidden">

                                    </div>
                                </div>
                                <div className="contents p-2">
                                    <AssetMetric height={(window.innerHeight - 580) / 2} data = {assets_data.data}/>
                                </div>
                            </div>

                            <div className="row-span-1 col-span-1 bg-[#FFFFFF] shadow-lg rounded-[5px]   ">
                                <div className="bg-[#ffffff] text-black px-3 py-1 flex-none flex rounded-tl-[5px] rounded-tr-[5px]">
                                    <div className="flex justify-center items-center gap-1 flex-nowrap overflow-hidden">

                                    </div>
                                </div>
                                <div className="contents p-2">
                                    <AssetStatusMetric height={(window.innerHeight - 580) / 2} data = {assets_data.status}/>
                                </div>
                            </div>

                            <div className="row-span-1 col-span-1 bg-[#FFFFFF] shadow-lg rounded-[5px]   ">
                                <div className="bg-[#ffffff] text-black px-3 py-1 flex-none flex rounded-tl-[5px] rounded-tr-[5px]">
                                    <div className="flex justify-center items-center gap-1 flex-nowrap overflow-hidden">

                                    </div>
                                </div>
                                <div className="contents p-2">
                                    <AssetQuarterMetric height={(window.innerHeight - 580) / 2} data = {assets_data.quarters}/>
                                </div>
                            </div>


                            <div className="row-span-1 col-span-2 bg-[#FFFFFF] shadow-lg rounded-[5px]   ">
                                <div className="bg-[#ffffff] text-black px-3 py-1 flex-none flex rounded-tl-[5px] rounded-tr-[5px]">
                                    <div className="flex justify-center items-center gap-1 flex-nowrap overflow-hidden">

                                    </div>
                                </div>
                                <div className="contents p-2">
                                    <TopAssets height={(window.innerHeight - 580) / 2}  assets = {assets_data.topAssets}/>
                                </div>
                            </div>

                            <div className="row-span-2 col-span-5 bg-[#FFFFFF] shadow-lg rounded-[5px]    ">
                                <div className="bg-[#ffffff] text-black px-3 py-1 flex-none flex rounded-tl-[5px] rounded-tr-[5px]">
                                </div>
                                <div className="flex-1">
                                    <AssetMap rawData={assets_data.location} />
                                </div>
                            </div>
                        </div>
                    </div>

                    

                
                </>)}

        </div>
        
    );
};

const mapStateToProps = (state) => {
    //console.log("ASsets", state.asset)
    return {
        assets: state.asset.assets,
        loading: state.asset.loading,
        error: state.asset.error,
        sidebar_collapsed: state.auth.sidebar_collapsed,
        assets_data: state.asset.assets_stat_data
    }
}

const mapDispatchToProps = (dispatch) => ({
    getInventoryFN: () => dispatch(getInventory()),
    deleteAssetFN: (id) => dispatch(deleteAsset(id)),
    getAssetStatsFN: () => dispatch(getAssetStats()),
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(ITInventory);
